import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs/internal/Subscription";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";

@Component({
  selector: "app-form-items-validate",
  templateUrl: "./form-items-validate.component.html",
  styleUrls: ["./form-items-validate.component.scss"],
})
export class FormItemsValidateComponent implements OnInit {
  @Input() notification: any;
  indiceTab: number = 0;
  decisionForm: FormGroup;
  items: any[] = [];
  pendingChanges: any = null;
  user: any;
  busyGet: Subscription;

  // keys you want to rename
  keys_to_rename = {
    created_at: "Created At",
    updated_at: "Updated At",
    deleted_at: "Deleted At",
    is_notif: "Is Notif",
    is_pending_validate: "Is Pending Validate",
    // add more if needed
  };

  // keys you want removed
  keys_to_remove = [
    "deleted_ip_address",
    "updated_ip_address",
    "created_by",
    "created_at",
    "updated_by",
    "updated_at",
    "is_notif",
    "code",
    "codification",
    "filiale",
    "is_pending_validate",
    "deleted_by",
    "deleted_at",
    "is_deleted",
    "created_ip_address",
    "password",
    // "file_url"
    // add more if needed
  ];

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer,
  ) {
    this.decisionForm = this.fb.group({
      decision: ["", Validators.required],
      reason: [""],
    });
    this.user = this.authService.getCurrentUser();
  }

  isInvalid(controlName: string): boolean {
    const control = this.decisionForm.get(controlName);
    return control?.invalid && control?.touched;
  }

  onSubmit() {
    if (this.decisionForm.valid) {
      console.log("Formulaire soumis :", this.decisionForm.value);
      alert("Décision soumise avec succès !");
    } else {
      this.decisionForm.markAllAsTouched();
    }
  }
  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  ngOnInit(): void {
    console.log("current notif", this.notification);
    this.getItems();
  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      data: {
        table_name: this.notification.table_name,
        target_row_id: this.notification.target_row_id,
        notification_id: this.notification.id,
      },
      index: 0,
      size: 1000,
    };

    this.busyGet = this.restClient
      .post("notification/getItemToValidate", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            const raw = res["items"][0];
            this.pendingChanges = raw.pending_changes || null;
            this.items = this.transformItems(res["items"]);
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );
            this.items = [];
          }
        },
        (err) => {},
      );
  }

  isChanged(key: string): boolean {
    if (!this.pendingChanges) return false;
    const originalKey = Object.keys(this.pendingChanges).find((k) => k === key);
    return originalKey !== undefined;
  }

  getPendingValue(key: string): any {
    if (!this.pendingChanges) return null;
    return this.pendingChanges[key] ?? null;
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  formatLabel(key: string): string {
    // Change snake_case to spaced Capitalized words
    return key
      .replace(/_/g, " ") // underscores → spaces
      .replace(/\b\w/g, (l) => l.toUpperCase()); // capitalize
  }

  transformItems(items: any[]) {
    return items.map((item) => {
      const newItem: any = {};

      Object.keys(item).forEach((key) => {
        // skip keys to remove
        if (this.keys_to_remove.includes(key)) {
          return;
        }

        // rename keys if found
        const newKey = this.keys_to_rename[key] ?? key;

        newItem[newKey] = item[key];
      });

      return newItem;
    });
  }

  previewOpen = false;
  previewSrc = "";

  openPreview(src: string) {
    this.previewSrc = src;
    this.previewOpen = true;
  }

  closePreview() {
    this.previewOpen = false;
    this.previewSrc = "";
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = "assets/images/custom/image-placeholder.jpg"; // optional fallback
  }
}
